import React from 'react';

const ProjectCard = ({ title, subtitle, description, liveLink, codeLink, imageSrc, imageClass, isReversed }) => {
    const infoContent = (
        <div className="project__info">
            <h3 className="project__title">
                {title}
                <br/>
                {subtitle}
            </h3>
            <p className="project__description">{description}</p>
            {codeLink && (
                <a href={codeLink} target="_blank" rel="noopener noreferrer">
                    <div className="project__live-2">Github Link</div>
                </a>
            )}
        </div>
    );

    const imageContent = (
        <a href={liveLink} target="_blank" rel="noopener noreferrer">
            <div className={`project__image-container ${imageClass}`}>
                <div className="project__image-image">
                    <img src={imageSrc} alt={`${title} screenshot`} />
                </div>
            </div>
        </a>
    );


    const projectClass = isReversed ? "project project-right" : "project project-left";

    return (
        <div className={projectClass}>
            {isReversed ? (
                <>
                    {infoContent}
                    {imageContent}
                </>
            ) : (
                <>
                    {imageContent}
                    {infoContent}
                </>
            )}
        </div>
    );
};

export default ProjectCard;